import { omit } from 'lodash-es';
import type { CSSProperties, FC, RefObject } from 'react';
import type { SpringConfig } from 'react-spring';
import { animated, Transition, useSpring } from 'react-spring';
import { useIsLowConfig } from 'src/services/app';

export const OpacityTransitionBox: FC<{ className?: string }> = (props) => {
  const { children, className } = props;

  return (
    <Transition
      items={[children]}
      {...{
        config: { duration: 200 },
        from: { opacity: 0.3 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        to: { opacity: 1 },
      }}
    >
      {(style: CSSProperties, item) =>
        item && (
          <animated.div className={className} style={style}>
            {item}
          </animated.div>
        )
      }
    </Transition>
  );
};

interface TransitionBoxProps extends Omit<JSX.IntrinsicElements['div'], 'ref'> {
  className?: string;
  domRef?: RefObject<HTMLDivElement>;
  style?: CSSProperties;
  tagName?: 'main' | 'span' | 'aside';
  config?: SpringConfig;
  springProp?: any;
}
export const TransitionBox: FC<TransitionBoxProps> = (props) => {
  const {
    children,
    config: _config,
    springProp: _springProp,
    tagName: _tagName,
    domRef,
    ...reset
  } = props;
  const isLowConfig = useIsLowConfig();

  if (isLowConfig) {
    const Tag = props.tagName ?? 'div';
    return (
      <Tag ref={domRef} {...reset}>
        {children}
      </Tag>
    );
  }

  return <TransitionBox0 {...omit(props, 'disableSpring')} />;
};

const TransitionBox0: FC<TransitionBoxProps> = (props) => {
  const {
    children,
    className,
    domRef,
    style = {},
    tagName = 'div',
    config = {},
    springProp = {},
    ...reset
  } = props;
  const springProps = useSpring({
    ...style,
    ...springProp,
    config: {
      ...config,
    },
  });

  const Tag = animated[tagName];

  return (
    <Tag ref={domRef} className={className} style={springProps} {...reset}>
      {children}
    </Tag>
  );
};
